<template>
  <v-row align="center" justify="center">
    <v-col class="pa-0" cols="12" lg="12" sm="12" md="12" xl="8">
      <v-carousel
        v-editable="blok"
        :height="isBreakpoint"
        show-arrows-on-hover
        hide-delimiters
        cycle
      >
        <component
          v-for="item in blok.body"
          :key="item._uid"
          :blok="item"
          :is="item.component"
        ></component>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Carousel",
  props: ["blok"],
  computed: {
    isBreakpoint() {
      if (this.$vuetify.breakpoint.xlOnly) {
        return "450px";
      } else if (this.$vuetify.breakpoint.lgOnly) {
        return "450px";
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return "450px";
      } else {
        return "500px";
      }
    }
  }
};
</script>

<style scoped></style>
